import React, { useState } from 'react';
import { DEFAULT_CURRENCY_CODE } from '@/utils/money';
import {
  FilteredCategoryItemGroup,
  OrderGuideProviderProps,
  PartitionFilterType,
} from './item-context-types';
import { OrderGuideItemsContext } from './order-guide-items-context';

export const DummyOrderGuideItemsContextProvider: React.FC<
  OrderGuideProviderProps
> = ({ children }) => {
  const [partitionFilter, setPartitionFilter] =
    useState<PartitionFilterType | null>(null);
  const [categoryFilter, setCategoryFilter] = useState<string | null>(null);
  const [categoryItemGroupFilter, setCategoryItemGroupFilter] =
    useState<FilteredCategoryItemGroup | null>(null);
  const itemsContextValue = {
    allVariantPacks: [],
    categories: [],
    categoryFilter,
    categoryItemGroupFilter,
    categoryItemGroups: [],
    collections: [],
    currencyCode: DEFAULT_CURRENCY_CODE,
    hasResponse: false,
    isInOrderGuide: () => false,
    loading: false,
    partitionFilter: partitionFilter,
    partitionFilters: [],
    partitionToCollectionMap: new Map(),
    refetch: async () => {},
    sections: [],
    selectedCollection: null,
    setCategoryFilter,
    setCategoryItemGroupFilter,
    setPartitionFilter,
    variantPackPartitionMap: {},
  };
  return (
    <OrderGuideItemsContext.Provider value={itemsContextValue}>
      {children}
    </OrderGuideItemsContext.Provider>
  );
};
